<template>
  <div class="grid-pages">
    <slot :data="data" :loading="loading"></slot>
    <div class="paging" :class="{'no-border' : !border}">
      <el-pagination background
                     :layout="noPageSize ? 'total, prev, pager, next, jumper' : 'sizes, total, prev, pager, next, jumper'"
                     :current-page="currentpage"
                     :page-sizes="pageSizes"
                     :page-size="pageSize"
                     :total="TotalCount"
                     @current-change="onCurrentChange"
                     @size-change="onSizeChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      url: {
        type: String,
        required: true
      },
      border: {
        type: Boolean,
        default: true
      },
      params: {
        type: [String, Object],
        default: ''
      },
      manually: {
        type: Boolean,
        default: false
      },
      pageSize: {
        type: Number,
        default: 10
      },
      noPageSize: {
        type: Boolean,
        default: false
      },
      pageSizes: {
        type: Array,
        default: () => [10, 50, 100]
      }
    },
    data() {
      return {
        currentpage: 1,
        TotalCount: 0,
        size: 10,
        data: [],
        loading: false
      }
    },
    methods: {
      loadData(url) {
        let self = this;
        if(url == null) url = self.url;
        self.loading = true;
        self.$http.post(url, {
          PageIndex: self.currentpage,
          PageSize: self.size,
          Data: self.params
        }).then(result => {
          if (result.state == true) {
            self.TotalCount = result.data.TotalCount;
            self.data = result.data.Data;
            self.$emit('loaded',result.data.Data);
          } else {
            self.data = [];
            self.TotalCount = 0;
            // self.$message.error(result.message||'');
            self.$emit('loaded',[]);
          }

          self.loading = false;
        }, () => {
          self.$message.error('获取数据失败，请检查您的网络是否可用。');
          self.loading = false;
        });
      },
      reload(url){
        this.currentpage = 1;
        this.loadData(url);
      },
      reloadsearch(ops){
        this.currentpage = 1;
        let self = this;
        self.loading = true;
        self.$http.post(self.url, {
          PageIndex: self.currentpage,
          PageSize: self.size,
          Data: ops
        }).then(result => {
          if (result.state == true) {
            self.TotalCount = result.data.TotalCount;
            self.data = result.data.Data;
          } else {
            self.data = [];
            self.TotalCount = 0;
          }
          self.$emit('loaded',result.data.Data);
          self.loading = false;
        }, () => {
          self.$message.error('获取数据失败，请检查您的网络是否可用。');
          self.loading = false;
        });
      },
      onSizeChange(val) {
        this.size = val;
        this.reload();
      },
      onCurrentChange(val) {
        this.currentpage = val;
        this.loadData();
      }
    },
    mounted() {
      this.size = this.pageSize;
      if (!this.manually)
        this.loadData();
    },
    computed: {
      tableHeight() {
        return this.screen.height - 200;
      }
    }
  }

</script>
<style>
  .paging .el-pagination::after, .el-pagination::before{
    display: inline-block;
  }
</style>
<style scoped>
  .grid-pages {
    background: #FFF;
  }

  .grid-pages .paging {
    border: 1px solid #EBEEF5;
    border-top: none;
    padding: 10px;
    text-align: center;
  }

  .grid-pages .paging.no-border {
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Table/Paging.vue